// import axios from 'axios';
import React, { useEffect, useState } from "react";
// import { useQuery } from 'react-query';
import { useNavigate } from "react-router-dom";
// import * as XLSX from "xlsx";
 import Images from '../../../asstes';
 import {getViewsalescom}from "../Api/GlobalApi";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useTable } from "react-table";
// import '../../../assets/styles.css'; 


//  import Viewsalescom from '../../../assets'; 

//  import assets from '../../..src/assets';
//  import icon from '../../assets/icon.svg`';

//  import {getViewCustomer}from "../Api/GlobalApi";
// import Images from "../../assets";
//  import assets from 'src/assets';
// import assets from "../../assets";
import axios from "axios";
import { useQuery } from "react-query";
import PopupModal from "../popupmodal/PopupModal";
import { fetchDataManagement } from "../Api/GlobalApi";
// import { display } from "html2canvas/dist/types/css/property-descriptors/display";
// import ReactPaginate from "react-paginate";
export default function Viewsalescom() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [popupState, setPopupState] = useState({
    removeConfirm: false,
    deleteId: null,
    removeSucess: false,
  });

  const { data, isLoading, isError, refetch, isFetched } = useQuery(
    "data",
    fetchDataManagement
  );
  const [selectedSales, setSelectedSales] = useState(data);

  // Function to close the modal
  const closeModal = () => {
    setIsOpen(false);
    setPopupState({
      removeConfirm: false,
      removeSucess: false,
      deleteId: null,
    });
  };
  const openDeleteModal = (registerNumber) => {
    setIsOpen(true);
    setPopupState({
      removeConfirm: true,
      deleteId: registerNumber, // Pass the register number for deletion
    });
  };

  //  const getValueData = data?.data

  const deletetogglePopup = async (state) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_HOST}/sales/deleteSales/${state}`
      );
    } catch (error) {
      console.log("Error", error);
    }
    refetch();
    setPopupState({
      removeConfirm: false,
      removeSucess: true,
    });
    // setPopupOpen(false);
  };
  // console.log("values", data?.data);
  // const updateFunction = (customerId) => {
  //   try {
  //     console.log("Fetched Data:", data?.data);
  //     console.log("Customer ID to match:", customerId);
  //     const values = data?.data?.filter(
  //       (ele) => String(ele?.customerId) === String(customerId)
  //     );
  //     // const values = data?.data?.filter((item)=>
  //     //   String(item?.customerId) === String(customerId)
  //     //   //  console.log('String(item?.customerId)',String(item?.customerId));

  //     // )
  //     console.log("values",data, );
  //     console.log("fetchDataManagement",data?.data,customerId);
  //     // console.log('');

  //     if (values?.length > 0) {
  //       console.log("Matching customer found:", values);
  //       navigate("/AddSales", { state: values });
  //     } else {
  //       console.warn("No matching customer found.");
  //     }
  //   } catch (error) {
  //     console.error("Error during navigation:", error);
  //   }
  // };
  useEffect(() => {
    try {
      // Filter the data based on the customerId
      const values =
        data &&
        data?.data?.filter(
          (ele) => String(ele?.customerId) === String(selectedSales)
        );
      if (values?.length > 0) {
        // console.log("Matching customer found:", values);
        // Navigate to NewQuotation page with the matching data
        navigate("/SalesInvoive", { state: values });
      } else {
        console.warn("No matching customer found.");
      }
    } catch (error) {
      console.error("Error during navigation:", error);
    }
  }, [data, selectedSales]);
 const downloadExcel = () => {
    // Prepare empty data if there's no valid data to export
    const exportData =
      filteredData && filteredData?.length > 0 ? filteredData : data;

    const tableDatas =
      exportData && exportData?.length > 0
        ? exportData?.map((data, index) => ({
            "S.NO": index + 1,
            "CUSTOMER ID": data?.customerId || null,
            "COMPANY NAME": data?.companyName || null,
            "CLIENT NAME": data?.customerName|| null,
            // "MOBILE NUMBER": data?.phoneNumber || null,
            "DESIGNATION": data?.description || null,
            "paymentMode":data?.paymentMode  ||null,           
            "DATE OF ENQUIRY": data?.startDate|| null,
            // "NEED": data?.need|| null,
            "DESCRIPTION": data?.description || null,
            // "TELE CALLER NAME": data?.telecallerName || null,
            // "TELE CALLER NUMBER": data?.telecallerMobNo || null,
            "paymentDate": data?.paymentDate|| null,
            "Address":data?.address || null,
            "projectAmount":data?.projectAmount || null,
            "CGST":data?.cgst|| null,
            "SGST":data?.sgst||null,
            "Invoice Type":data?.invoiceType||null
          }))
        : []; // Default to an empty array

    // Create a new workbook and add an empty sheet if there's no data
    const workbook = XLSX.utils.book_new();
    const tableWorksheet = XLSX.utils.json_to_sheet(
      tableDatas?.length > 0 ? tableDatas : [{}],
      {
        skipHeader: false,
      }
    );

    // Optionally set headers even if no data
    if (tableDatas?.length === 0) {
      XLSX.utils.sheet_add_aoa(tableWorksheet, [
        [
          "S.NO",
          "CUSTOMER ID",
          "COMPANY NAME",
          "CLIENTNAME",
          // "MOBILE NUMBER",
          "DESIGNATION",
          // "NEED",
          "paymentMode",
          "DATE OF ENQUIRY",
          "DESCRIPTION",
          // "TELE CALLER NAME",
          // "TELE CALLER NUMBER",
          "Address",
          "projectAmount",
          "CGST",
          "SGST",
          "Invoice Type"
        ],
      ]);
    }

    XLSX.utils.book_append_sheet(workbook, tableWorksheet, "Table Data");

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save the Excel file
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "View sales.xlsx");
  };


  const columns = React.useMemo(
    () => [
      // { Header: "S.No", accessor: "sno" },
      { Header: "Invoice Type", accessor: "invoiceType" },
      { Header: "Customer Id", accessor: "customerId" },
      { Header: "Customer Name", accessor: "customerName" },
      { Header: "Company Name", accessor: "companyName" },
      { Header: "Address", accessor: "address" },
      // { Header: "City", accessor: "city" },
      // { Header: "Pincode", accessor: "pincode" },
      { Header: "Start Date", accessor: "startDate" },
      { Header: "Description", accessor: "description" },
      { Header: "Payment Mode", accessor: "paymentMode" },
      { Header: "Payment Date", accessor: "paymentDate" },
      { Header: "projectAmount", accessor: "projectAmount" },
      { Header: "CGST", accessor: "cgst" },
      { Header: "SGST", accessor: "sgst" },
     
      // { Header: "Product Copy", accessor: "productCopy" },
      {
        Header: "Product Copy",
        accessor: "productCopy",
        Cell: ({ row }) => (
          // console.log("FFFFF", )

          <div>
            <button
              // onClick={() => deletetogglePopup(row.original.employeeId)}
              onClick={() => deletetogglePopup(row.original.customerId)}
              style={{
                marginRight: "10px",
                cursor: "pointer",
                border: "none",
                background: "transparent",
              }}
               title="Delete"
            >
              🗑️
            </button>
            <button
              onClick={
                () =>
                  // setDeleteIndex()
                  setSelectedSales(row.original.customerId)
                // navigate("/", { state: values })
              }
              //  setSelectedCustomer(row.original.customerId)}
              style={{
                cursor: "pointer",
                border: "none",
                background: "transparent",
              }}
              title="Edit"
            >
              ✏️
            </button>
          </div>
        ),
      },
      {
        Header: "Download Quotation",
        accessor: "downloadquotation",
        Cell: ({ row }) => (
          // console.log("FFFFF", )

          <div class="download-icon">
            <button
              onClick={() => setSelectedSales(row.original.customerId)}
              style={{
                cursor: "pointer",
                border: "none",
                background: "transparent",
                width: "40px",
                height: "25px",
                objectFit: "contain",
                display: "flex",
                justifyContent: "flex-end",
                margin: "left",
              }}
            >
              <img
                src={Images?.downloadIcon}
                alt="No-Image"
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  cursor:"pointer"
                }}
                 
                  onClick={()=>{
                    downloadExcel();
                
                }}
              />
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const tabelcolums = data?.data.map((item) => ({
    ...item,
    address: `${item.flatNo ? item.flatNo : ""}, ${
      item.street ? item.street : ""
    }, ${item.area ? item.area : ""}, ${item.city ? item.city : ""}, ${
      item.state ? item.state : ""
    } - ${item.pincode ? item.pincode : 0}`,
    select: <input type="checkbox" />,
  }));

  const filteredData =
    tabelcolums && tabelcolums
      ? tabelcolums &&
        tabelcolums?.filter((item) => {
          console.log("item", item);
          return (
            item?.customerId
              ?.toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            item?.customerName?.toLowerCase().includes(searchTerm.toLowerCase())
          );
        })
      : [];
  const tableInstance = useTable({ columns, data: filteredData });
  console.log("filteredData", filteredData);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;
  // console.log("tabelcolums", tabelcolums, "columns", columns, "tableInstance", tableInstance);
  console.log("rows", rows);
  return (
    <>
      <div className="viewtable">
        <div style={{display:"flex",flexDirection:"row",justifycontent: "flex-end",width:"100%", objectFit: "contain",gap:"70%",alignItems: "center"}}>
          

          <div
            className="searchbaremptab"
            style={{
              display: "flex",
              alignItems: "center",
              background: "#fff",
              width: "20%",
              margin: "15px 25px",
              height: "35px",
              borderRadius: "5px",
              justifyContent: "rows",
              padding: "0px 10px",
              border: "2px solid #7a1cac",
            }}
          >
            <input
              type="text"
              className=" search"
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                border: "none",
                outline: "none",
                borderRadius: "0px",
                height: "20PX",
              }}
            ></input>

            <div style={{ width: "22px", height: "22px" }}>
              <img
                src={Images.searchIcon}
                alt="searchicon"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
          <div className="download-icon">
            <img
              src={Images?.downloadIcon}
              width="100%"
              height="100%"
              alt="No-Image"
              style={{ cursor: "pointer" }}
              onClick={() => {
                downloadExcel();
              }}
            />
          </div>
        </div>

        <div className="emptable">
          <table className="empdetailstable" cellPadding="10px">
            <thead>
              {headerGroups?.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      className="viewcustomerheader"
                      {...column.getHeaderProps()}
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            {/* <tbody>
              {rows?.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()} className="viewcustomerdata">
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody> */}
            <tbody {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row) => {
                  console.log("row", row);
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td
                          className="viewcustomerdata"
                          {...cell.getCellProps()}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={columns.length}
                    style={{ textAlign: "center", padding: "10px" }}
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <PopupModal
        isOpen={isOpen}
        onClose={closeModal}
        popupState={popupState}
        setPopupState={setPopupState}
        deleteHandler={deletetogglePopup}
        isLoading={isLoading}
        message="SALES HAS BEEN DELETED SUCCESSFULLY"
      />
    </>
  );
}
